import { useState as n, useReducer as t, useEffect as e, useLayoutEffect as r, useRef as u, useImperativeHandle as o, useMemo as i, useCallback as l, useContext as f, useDebugValue as c } from "preact/hooks";
export * from "preact/hooks";
import { Component as a, createElement as s, options as h, toChildArray as v, Fragment as d, render as p, hydrate as m, cloneElement as y, createRef as b, createContext as _ } from "preact";
export { createElement, createContext, createRef, Fragment, Component } from "preact";

function S(n, t) {
  for (var e in t) {
    n[e] = t[e];
  }

  return n;
}

function C(n, t) {
  for (var e in n) {
    if ("__source" !== e && !(e in t)) return !0;
  }

  for (var r in t) {
    if ("__source" !== r && n[r] !== t[r]) return !0;
  }

  return !1;
}

function E(n) {
  this.props = n;
}

function g(n, t) {
  function e(n) {
    var e = this.props.ref,
        r = e == n.ref;
    return !r && e && (e.call ? e(null) : e.current = null), t ? !t(this.props, n) || !r : C(this.props, n);
  }

  function r(t) {
    return this.shouldComponentUpdate = e, s(n, t);
  }

  return r.displayName = "Memo(" + (n.displayName || n.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r;
}

(E.prototype = new a()).isPureReactComponent = !0, E.prototype.shouldComponentUpdate = function (n, t) {
  return C(this.props, n) || C(this.state, t);
};
var w = h.__b;

h.__b = function (n) {
  n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), w && w(n);
};

var x = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;

function R(n) {
  function t(t) {
    var e = S({}, t);
    return delete e.ref, n(e, t.ref || null);
  }

  return t.$$typeof = x, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}

var N = function N(n, t) {
  return null == n ? null : v(v(n).map(t));
},
    k = {
  map: N,
  forEach: N,
  count: function count(n) {
    return n ? v(n).length : 0;
  },
  only: function only(n) {
    var t = v(n);
    if (1 !== t.length) throw "Children.only";
    return t[0];
  },
  toArray: v
},
    A = h.__e;

h.__e = function (n, t, e, r) {
  if (n.then) for (var u, o = t; o = o.__;) {
    if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
  }
  A(n, t, e, r);
};

var O = h.unmount;

function T() {
  this.__u = 0, this.t = null, this.__b = null;
}

function L(n) {
  var t = n.__.__c;
  return t && t.__a && t.__a(n);
}

function U(n) {
  var t, e, r;

  function u(u) {
    if (t || (t = n()).then(function (n) {
      e = n.default || n;
    }, function (n) {
      r = n;
    }), r) throw r;
    if (!e) throw t;
    return s(e, u);
  }

  return u.displayName = "Lazy", u.__f = !0, u;
}

function D() {
  this.u = null, this.o = null;
}

h.unmount = function (n) {
  var t = n.__c;
  t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), O && O(n);
}, (T.prototype = new a()).__c = function (n, t) {
  var e = t.__c,
      r = this;
  null == r.t && (r.t = []), r.t.push(e);

  var u = L(r.__v),
      o = !1,
      i = function i() {
    o || (o = !0, e.__R = null, u ? u(l) : l());
  };

  e.__R = i;

  var l = function l() {
    if (! --r.__u) {
      if (r.state.__a) {
        var n = r.state.__a;

        r.__v.__k[0] = function n(t, e, r) {
          return t && (t.__v = null, t.__k = t.__k && t.__k.map(function (t) {
            return n(t, e, r);
          }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
        }(n, n.__c.__P, n.__c.__O);
      }

      var t;

      for (r.setState({
        __a: r.__b = null
      }); t = r.t.pop();) {
        t.forceUpdate();
      }
    }
  },
      f = !0 === t.__h;

  r.__u++ || f || r.setState({
    __a: r.__b = r.__v.__k[0]
  }), n.then(i, i);
}, T.prototype.componentWillUnmount = function () {
  this.t = [];
}, T.prototype.render = function (n, t) {
  if (this.__b) {
    if (this.__v.__k) {
      var e = document.createElement("div"),
          r = this.__v.__k[0].__c;

      this.__v.__k[0] = function n(t, e, r) {
        return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function (n) {
          "function" == typeof n.__c && n.__c();
        }), t.__c.__H = null), null != (t = S({}, t)).__c && (t.__c.__P === r && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function (t) {
          return n(t, e, r);
        })), t;
      }(this.__b, e, r.__O = r.__P);
    }

    this.__b = null;
  }

  var u = t.__a && s(d, null, n.fallback);
  return u && (u.__h = null), [s(d, null, t.__a ? null : n.children), u];
};

var F = function F(n, t, e) {
  if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for (e = n.u; e;) {
    for (; e.length > 3;) {
      e.pop()();
    }

    if (e[1] < e[0]) break;
    n.u = e = e[2];
  }
};

function I(n) {
  return this.getChildContext = function () {
    return n.context;
  }, n.children;
}

function M(n) {
  var t = this,
      e = n.i;
  t.componentWillUnmount = function () {
    p(null, t.l), t.l = null, t.i = null;
  }, t.i && t.i !== e && t.componentWillUnmount(), n.__v ? (t.l || (t.i = e, t.l = {
    nodeType: 1,
    parentNode: e,
    childNodes: [],
    appendChild: function appendChild(n) {
      this.childNodes.push(n), t.i.appendChild(n);
    },
    insertBefore: function insertBefore(n, e) {
      this.childNodes.push(n), t.i.appendChild(n);
    },
    removeChild: function removeChild(n) {
      this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), t.i.removeChild(n);
    }
  }), p(s(I, {
    context: t.context
  }, n.__v), t.l)) : t.l && t.componentWillUnmount();
}

function V(n, t) {
  var e = s(M, {
    __v: n,
    i: t
  });
  return e.containerInfo = t, e;
}

(D.prototype = new a()).__a = function (n) {
  var t = this,
      e = L(t.__v),
      r = t.o.get(n);
  return r[0]++, function (u) {
    var o = function o() {
      t.props.revealOrder ? (r.push(u), F(t, n, r)) : u();
    };

    e ? e(o) : o();
  };
}, D.prototype.render = function (n) {
  this.u = null, this.o = new Map();
  var t = v(n.children);
  n.revealOrder && "b" === n.revealOrder[0] && t.reverse();

  for (var e = t.length; e--;) {
    this.o.set(t[e], this.u = [1, 0, this.u]);
  }

  return n.children;
}, D.prototype.componentDidUpdate = D.prototype.componentDidMount = function () {
  var n = this;
  this.o.forEach(function (t, e) {
    F(n, e, t);
  });
};

var W = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
    P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|shape|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
    $ = "undefined" != typeof document,
    j = function j(n) {
  return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};

function z(n, t, e) {
  return null == t.__k && (t.textContent = ""), p(n, t), "function" == typeof e && e(), n ? n.__c : null;
}

function B(n, t, e) {
  return m(n, t), "function" == typeof e && e(), n ? n.__c : null;
}

a.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function (n) {
  Object.defineProperty(a.prototype, n, {
    configurable: !0,
    get: function get() {
      return this["UNSAFE_" + n];
    },
    set: function set(t) {
      Object.defineProperty(this, n, {
        configurable: !0,
        writable: !0,
        value: t
      });
    }
  });
});
var H = h.event;

function Z() {}

function Y() {
  return this.cancelBubble;
}

function q() {
  return this.defaultPrevented;
}

h.event = function (n) {
  return H && (n = H(n)), n.persist = Z, n.isPropagationStopped = Y, n.isDefaultPrevented = q, n.nativeEvent = n;
};

var G,
    J = {
  configurable: !0,
  get: function get() {
    return this.class;
  }
},
    K = h.vnode;

h.vnode = function (n) {
  var t = n.type,
      e = n.props,
      r = e;

  if ("string" == typeof t) {
    var u = -1 === t.indexOf("-");

    for (var o in r = {}, e) {
      var i = e[o];
      $ && "children" === o && "noscript" === t || "value" === o && "defaultValue" in e && null == i || ("defaultValue" === o && "value" in e && null == e.value ? o = "value" : "download" === o && !0 === i ? i = "" : /ondoubleclick/i.test(o) ? o = "ondblclick" : /^onchange(textarea|input)/i.test(o + t) && !j(e.type) ? o = "oninput" : /^onfocus$/i.test(o) ? o = "onfocusin" : /^onblur$/i.test(o) ? o = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(o) ? o = o.toLowerCase() : u && P.test(o) ? o = o.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === i && (i = void 0), /^oninput$/i.test(o) && (o = o.toLowerCase(), r[o] && (o = "oninputCapture")), r[o] = i);
    }

    "select" == t && r.multiple && Array.isArray(r.value) && (r.value = v(e.children).forEach(function (n) {
      n.props.selected = -1 != r.value.indexOf(n.props.value);
    })), "select" == t && null != r.defaultValue && (r.value = v(e.children).forEach(function (n) {
      n.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(n.props.value) : r.defaultValue == n.props.value;
    })), n.props = r, e.class != e.className && (J.enumerable = "className" in e, null != e.className && (r.class = e.className), Object.defineProperty(r, "className", J));
  }

  n.$$typeof = W, K && K(n);
};

var Q = h.__r;

h.__r = function (n) {
  Q && Q(n), G = n.__c;
};

var X = {
  ReactCurrentDispatcher: {
    current: {
      readContext: function readContext(n) {
        return G.__n[n.__c].props.value;
      }
    }
  }
},
    nn = "17.0.2";

function tn(n) {
  return s.bind(null, n);
}

function en(n) {
  return !!n && n.$$typeof === W;
}

function rn(n) {
  return en(n) ? y.apply(null, arguments) : n;
}

function un(n) {
  return !!n.__k && (p(null, n), !0);
}

function on(n) {
  return n && (n.base || 1 === n.nodeType && n) || null;
}

var ln = function ln(n, t) {
  return n(t);
},
    fn = function fn(n, t) {
  return n(t);
},
    cn = d;

function an(n) {
  n();
}

function sn(n) {
  return n;
}

function hn() {
  return [!1, an];
}

var vn = r;

function dn(t, r) {
  var u = n(r),
      o = u[0],
      i = u[1];
  return e(function () {
    return t(function () {
      i(r());
    });
  }, [t, r]), o;
}

export default {
  useState: n,
  useReducer: t,
  useEffect: e,
  useLayoutEffect: r,
  useInsertionEffect: r,
  useTransition: hn,
  useDeferredValue: sn,
  useSyncExternalStore: dn,
  startTransition: an,
  useRef: u,
  useImperativeHandle: o,
  useMemo: i,
  useCallback: l,
  useContext: f,
  useDebugValue: c,
  version: "17.0.2",
  Children: k,
  render: z,
  hydrate: B,
  unmountComponentAtNode: un,
  createPortal: V,
  createElement: s,
  createContext: _,
  createFactory: tn,
  cloneElement: rn,
  createRef: b,
  Fragment: d,
  isValidElement: en,
  findDOMNode: on,
  Component: a,
  PureComponent: E,
  memo: g,
  forwardRef: R,
  flushSync: fn,
  unstable_batchedUpdates: ln,
  StrictMode: d,
  Suspense: T,
  SuspenseList: D,
  lazy: U,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: X
};
export { an as startTransition, sn as useDeferredValue, hn as useTransition, vn as useInsertionEffect, dn as useSyncExternalStore, nn as version, k as Children, z as render, B as hydrate, un as unmountComponentAtNode, V as createPortal, tn as createFactory, rn as cloneElement, en as isValidElement, on as findDOMNode, E as PureComponent, g as memo, R as forwardRef, fn as flushSync, ln as unstable_batchedUpdates, cn as StrictMode, T as Suspense, D as SuspenseList, U as lazy, X as __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED };